import { Reducer } from 'redux';
import { produce } from 'immer';

import { COVERAGE_TYPES, CoverageState } from './types';

export const INITIAL_STATE: CoverageState = {
  coverageList: [],
};

const reducer: Reducer<CoverageState> = (
  state = INITIAL_STATE,
  action = { type: '', payload: {} },
) => {
  return produce(state, draft => {
    switch (action.type) {
      case COVERAGE_TYPES.SET_DATA_COVERAGELIST:
        draft.coverageList = action.payload;
        break;
      default:
    }
  });
};

export default reducer;
